"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShopperContext = void 0;
var _commerceSdkIsomorphic = require("commerce-sdk-isomorphic");
var _utils = require("../utils");
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// We must use a client with no parameters in order to have required/optional match the API spec

// This is defined here, rather than `types.ts`, because it relies on `Client` and `QueryKeys`,
// and making those generic would add too much complexity.

const getShopperContext = exports.getShopperContext = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/shopper-context/', params.usid],
  queryKey: params => {
    return [...getShopperContext.path(params), (0, _utils.pickValidParams)(params, _commerceSdkIsomorphic.ShopperContexts.paramKeys.getShopperContext)];
  }
};